// extracted by mini-css-extract-plugin
export default {"bar":"Point_bar__3YyS2","item":"Point_item__RzW15"};